import React, { Component } from 'react'

import TabHeader from '@/companys/ttl/components/TabHeader/TabHeader'

import Chart from './DetailPage/Chart'
import Summary from './DetailPage/Summary'
import Index from './DetailPage/Index'
import HNews from './DetailPage/HNews'
import Comment from './DetailPage/Comment'
import Warrants from './DetailPage/Warrants'
import Financials from './DetailPage/Financials'

import '../../assets/styles/components/detail-center/detail-center.scss'
import { connect } from 'react-redux'
import { openChartDialog} from '@/actions/app'


class DetailCenter extends Component {
    constructor(props) {
        super(props)
        this.state = {
            portfolio: [
                { id: '1', title: 'chart', isActive: true },
                { id: '2', title: 'market_summary', isActive: false },
                { id: '3', title: 'market_index', isActive: false },
                { id: '4', title: 'market_financials', isActive: false },
                // { id: '5', title: 'market_h_new', isActive: false },
                // { id: '6', title: 'market_warrants', isActive: false },
                { id: '7', title: 'market_comment', isActive: false },
            ],
            tab: 'Chart',
        }
    }
    render() {
        const {language} = this.props
        const { portfolio, tab } = this.state
        return (
            <div className='detail_center'>
                <div className='header'>
                     {
                        <TabHeader tabs={portfolio} onChangeMainTab={this.handleChangeMainTab} refresh onRefresh={() => this.refresh(tab)}></TabHeader>
                    }
                </div>
                {tab == 'Chart' && <Chart />}              
                {tab == 'Summary' && <Summary innerRef={e => this.SummaryRef = e}/>}
                {tab == 'Index' && <Index innerRef={e=> this.IndexRef = e} />}
                {tab == 'Financials' && <Financials innerRef={e=> this.FinancialsRef = e}/>}
                {tab == 'HNews' && <HNews innerRef={e => this.HNewsRef = e} />}
                {tab == 'Warrants' && <Warrants quoteData={this.state.quoteData}  innerRef = {e => this.WarrantsRef = e}/>}
                {tab == 'Comment' && <Comment innerRef={e => this.CommentRef = e} /> }
            </div>
        )
    }
    componentDidMount() {
        document.getElementsByClassName('action-item')[0].style.display = 'none'
        document.getElementsByClassName('tab-header-container')[0].style.width = '100%'
        if(this.props.quoteData){
            this.setState({quoteData:this.props.quoteData })
        }
    }
    componentDidUpdate(preProps){
        if(this.props.quoteData && this.props.quoteData !== this.state.quoteData){
            this.setState({quoteData:this.props.quoteData })
        }
    }
    // 处理标签选项 
    handleChangeMainTab = (mainTab) => {
        switch (mainTab.id) {
            case '1':
                this.setState({ tab: 'Chart' })
                break
            case '2':
                this.setState({ tab: 'Summary' })
                break
            case '3':
                this.setState({ tab:"Index" })
                break
            case '4':
                this.setState({tab:'Financials'})
                break;
            case '5':
                this.setState({tab:'HNews'})
                break;
            case '6':
                this.setState({tab:'Warrants'})
                break;
            case '7':
                this.setState({tab:'Comment'})               
                break;
        }
    }

    refresh = (tab) =>{
        switch(tab){
            case 'Chart' :
                openChartDialog()
                break;
            case 'Summary' :
                this.SummaryRef.getMainIndex()
                this.SummaryRef.getCompanyProfile()
                this.SummaryRef.getDividends()
                break;
            case 'Index' :
                this.IndexRef.change()
                break;
            case 'Financials' :
                this.FinancialsRef.resetGetData()
                break;
            case 'HNews' :
                this.HNewsRef.refresh()
                break;
            case 'Warrants' :
                this.WarrantsRef.getWarrants()
                break;
            case 'Comment' :
                this.CommentRef.getPostList()
                break;
        }
    }

}


export default connect(
    (state) => ({
        language: state.app.language,
    }),
    (dispatch) => ({

    })
)(DetailCenter)